import template from './sw-cms-block-acris-blog-subtitle.html.twig';

const { Component } = Shopware;

Component.register('sw-cms-block-acris-blog-subtitle', {
    template
});
